<template>
    <div class="has-recoverBannedChip-component">
      <div class="column is-8 is-offset-2">
        <div class="columns mt-2">
          <div class="column is-full">
            <p class="is-size-3 has-text-centered has-text-grey-dark dm-sans">
              Gostaria de contratar o serviço para a tentativa de recuperação de chip banido?
            </p>
          </div>
        </div>
        <div class="columns">
          <div class="column is-full">
            <div class="buttons is-flex is-justify-content-center is-full">
              <button
                  class="button is-grey is-size-3 has-text-weight-bold mx-4 is-one-quarter"
                  @click.prevent="selectRecoverBanned(true)"
              >
                Sim
              </button>
              <button
                  class="button is-grey is-size-3 has-text-weight-bold mx-4 is-one-quarter"
                  @click.prevent="selectRecoverBanned(false)"
              >
                Não
              </button>
            </div>
          </div>
        </div>
        <div class="columns mt-3">
          <div class="column is-full">
            <ul class="custom-bullet-list is-size-5 has-text-left has-text-grey-dark dm-sans mt-4" style="max-width: 600px; margin: 0 auto;">
              <li>
                O custo inicial é de <strong>R$ {{ formatPrice(recoverBannedChip.price) }}</strong>.
              </li>
              <li>
                Este valor cobre uma tentativa de recuperação durante 60 dias.
              </li>
              <li>
                Um valor adicional de <strong>R$ {{ formatPrice(recoverBannedChip.price * 9) }}</strong> só é cobrado se o serviço for bem-sucedido e o número for recuperado.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </template>
  
<script>
  
    import recoverBannedChipApi from '@/apis/recoverBannedChip'
  
    export default {
  
        name: 'recover-banned-chip',
  
        data() {
            return {
                recoverBannedChip: {}
            }
        },
  
        props: {
            formData: {
                required: true,
                type: Object
            }
        },
  
        watch: {
            'formData.plan': {
                handler() {
                    this.getRecoverBannedChip()
                },
                deep: true
            }
        },
  
        methods: {
            cleanData() {
                this.formData.recoverBannedChip.data = {}
            },
            formatPrice(value) {
                return (parseFloat(value).toLocaleString('pt-BR', { currency: 'BRL', style: 'currency' }))
                    .replace('R$', '').trim();
            },
            selectRecoverBanned(option) {
                this.formData.recoverBannedChip.showStep = option
                this.formData.recoverBannedChip.data = this.recoverBannedChip
                this.$emit('nextTab')
            },
            async getRecoverBannedChip() {
                if (this.formData.plan.data.id) {
                    this.recoverBannedChip = await recoverBannedChipApi.get({
                        plan_id: this.formData.plan.data.id
                    })
                }
            }
        },
        mounted() {
            this.getRecoverBannedChip()
        }
  
  }
  
</script>
  
<style >
.custom-bullet-list {
  list-style-type: disc;
  padding-left: 1.5em;
}
.custom-bullet-list li::marker {
  color: #888;
  font-size: 1.2em;
}
</style>
  